import { MODEL_NAME } from "../config"

const CONFIG_FILE = `/models/${MODEL_NAME}/config.json`
const MODEL_FILE = `/models/${MODEL_NAME}/onnx/model_quantized.onnx`
const TOKENIZER_FILE = `/models/${MODEL_NAME}/tokenizer.json`
const TOKENIZER_CONFIG_FILE = `/models/${MODEL_NAME}/tokenizer_config.json`

const allFiles = [CONFIG_FILE, MODEL_FILE, TOKENIZER_FILE, TOKENIZER_CONFIG_FILE]

const CACHE_NAME = "transformers-cache"

export async function preloadAIAssets() {
    if (typeof window === "undefined" || !window.caches) {
        console.warn("No window or caches API available")
        return
    }

    const cache = await caches.open(CACHE_NAME)

    const alreadyInCache = await cache.keys()
    const alreadyInCacheUrls = alreadyInCache.map((request) => new URL(request.url).pathname)
    const toBeLoaded = allFiles.filter((url) => !alreadyInCacheUrls.includes(url))

    if (toBeLoaded.length === 0) {
        console.log("All AI assets are already in cache")
        return
    }

    const results = await Promise.allSettled(toBeLoaded.map((url) => cache.add(url)))

    const failed = results.filter((result) => result.status === "rejected")
    if (failed.length > 0) {
        console.error("Failed to preload some or all AI assets", failed)
        console.log("UserAgent:", navigator.userAgent)
        throw new Error("Failed to preload AI assets")
    }
}
